// extracted by mini-css-extract-plugin
export default {"icon":"AutoSave_icon__uPz2o"};